import { FilterDropdownProps } from 'antd/lib/table/interface'
import ColumnFilterWrapper from '../ColumnFilterWrapper'
import { useState } from 'react'
import { InputNumber, Row, Space } from 'antd'
import HelpIcon from '../../../../../../HelpIcon'
import { ColumnNumberSearchValue } from './types'

/**
 * Generate a unique id for each input field using a monotonically increasing
 * number. This ensures that each input field can be associated with its
 * respective label element, while avoiding the need to wrap everything in a
 * label, which would result in invalid HTML due to child components containing
 * <div> elements. The id will increment each time the component renders,
 * ensuring unique ids across the DOM.
 */
let id = 0

const ColumnNumberSearch: React.VFC<FilterDropdownProps> = ({
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
}) => {
  const [, setSearchValue] = useState<ColumnNumberSearchValue>({})
  const get = () =>
    selectedKeys[0]
      ? (JSON.parse(selectedKeys[0].toString()) as ColumnNumberSearchValue)
      : {}
  const set = (key: keyof ColumnNumberSearchValue, value: number | null) => {
    const next = { ...get(), [key]: value }
    if (typeof next.greater !== 'number' && typeof next.less !== 'number')
      return setSelectedKeys([])
    return setSelectedKeys([JSON.stringify(next)])
  }
  const greaterThanId = `column-number-search-greater-${id}`
  const lessThanId = `column-number-search-less-${id}`

  id++

  return (
    <ColumnFilterWrapper
      confirm={confirm}
      selectedKeys={selectedKeys}
      clearFilters={clearFilters}
      onOk={() => {
        const [value] = selectedKeys as unknown as [ColumnNumberSearchValue]
        setSearchValue({
          greater: value?.greater ?? null,
          less: value?.less ?? null,
        })
      }}
      onReset={() => setSearchValue({})}
    >
      <Space direction="vertical" size="small" style={{ width: 300 }}>
        <Row justify="space-between" align="middle">
          <HelpIcon text="Filter for values greater than or equal to this value">
            <label htmlFor={greaterThanId}>Greater or Equal</label>
          </HelpIcon>
          <InputNumber
            id={greaterThanId}
            value={get().greater}
            style={{ width: '50%' }}
            onChange={(value) => set('greater', value)}
          />
        </Row>
        <Row justify="space-between" align="middle">
          <HelpIcon text="Filter for values less than or equal to this value">
            <label htmlFor={lessThanId}>Less or Equal</label>
          </HelpIcon>
          <InputNumber
            id={lessThanId}
            value={get().less}
            style={{ width: '50%' }}
            onChange={(value) => set('less', value)}
          />
        </Row>
      </Space>
    </ColumnFilterWrapper>
  )
}

export default ColumnNumberSearch
